import { render, staticRenderFns } from "./authDialog.vue?vue&type=template&id=20450b57&scoped=true"
import script from "./authDialog.vue?vue&type=script&lang=js"
export * from "./authDialog.vue?vue&type=script&lang=js"
import style0 from "./authDialog.vue?vue&type=style&index=0&id=20450b57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20450b57",
  null
  
)

export default component.exports